import { h } from "omi";

import { IconProps } from "@/wc/components";

export function FileHeartIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={props.width} height={props.height} viewBox="0 0 18 18">
      <g clip-path="url(#a)">
        <path
          d="m14.1459 8.0556.0745-2.132c.0391-1.1194.0586-1.6792-.1443-2.1143a2 2 0 0 0-.843-.904c-.42-.2328-.9797-.2523-2.0991-.2915L6.87 2.465c-1.1195-.0391-1.6792-.0587-2.1144.1442a2 2 0 0 0-.904.843c-.2328.42-.2523.9797-.2914 2.0991l-.242 6.9291c-.039 1.1195-.0586 1.6792.1443 2.1143.1785.3828.4736.6993.843.904.42.2328.9797.2524 2.0991.2915l2.132.0744m3.4963-4.6604c-.5117-.6242-1.3945-.8182-2.0815-.2869-.687.5312-.8133 1.4552-.312 2.1294.5014.6742 2.25 2.2679 2.25 2.2679s1.8555-1.4679 2.4026-2.1055c.5472-.6375.4973-1.5735-.1626-2.1459-.6599-.5725-1.5425-.446-2.0965.141Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="rotate(2 -26.0476 30.6754)" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
